
@switch (columnId) {
  @case ('tid') {
    <lib-text-table-column>
      {{ element.tid }}
    </lib-text-table-column>
  }
  @case ('mid') {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('processor') {
    <lib-text-table-column>
      {{ element.processor }}
    </lib-text-table-column>
  }
  @case ('gateway') {
    <lib-text-table-column>
      {{ element.gateway }}
    </lib-text-table-column>
  }
  @case ('mai') {
    <lib-text-table-column>
      {{ element.mai }}
    </lib-text-table-column>
  }
  @case ('deviceSerial') {
    <lib-text-table-column>
      {{ element.posConfig?.deviceSerial }}
    </lib-text-table-column>
  }
  @case ('deviceName') {
    <lib-text-table-column>
      {{ element.posConfig?.deviceName }}
    </lib-text-table-column>
  }
  @case ('deviceLocation') {
    <lib-text-table-column>
      {{ element.posConfig?.deviceLocation }}
    </lib-text-table-column>
  }
  @case ('status') {
    @if (element.posConfig?.status) {
      <lib-status-chip
        class="pos-terminal-statuses"
        [status]="element.posConfig?.status">
      </lib-status-chip>
    } @else {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @case ('deletedUtc') {
    @if (showingDeletedTids) {
      <lib-date-time-label [dateUtc]="element?.deletedUtc">
      </lib-date-time-label>
      <lib-table-column-sort [key]="sortingKeyForDateDeleted"></lib-table-column-sort>
    }
  }
  @default {
  }
}





